import { useEffect, useState } from 'react';
import { useSearchParamsWithApiKey } from '../../tools';

interface UseConvertRasterToVectorParams {
    imageUrl: string | null;
    setImageUrl: (url: string) => void;
}

export const useConvertRasterToVectorParams = (): UseConvertRasterToVectorParams => {
    const [searchParams, setSearchParams] = useSearchParamsWithApiKey();
    const imageUrlParam = searchParams.get('imageUrl');
    const [imageUrl, setImageUrl] = useState(imageUrlParam ?? '');

    useEffect(() => {
        const searchParamsObj: Record<string, string | string[]> = {};

        if (imageUrl) {
            searchParamsObj['imageUrl'] = imageUrl;
        }

        setSearchParams(searchParamsObj);
    }, [imageUrl, setSearchParams]);

    return {
        imageUrl,
        setImageUrl,
    };
};
